import { combineReducers } from 'redux';
import { apiInitialState } from 'ml-fetch';

const formReducer = (state = { submitting: false }, action) => {
	function updateApiState(state = apiInitialState(), action) {
		let formData = state.data ? state.data.data : {};
		switch (action.type) {
			case 'FORM_FIELD_UPDATED':
				return {
					...state,
					data: {
						...state.data,
						data: {
							...formData,
							[action.field]: action.value
						}
					}
				}

			case 'RESET_FORM':
				return {
					...state,
					data: {
						...state.data,
						submitting: false,
						data: {},
						status: undefined
					}
				}

			case 'SUBMIT_FORM_REQUEST':
				return {
					...state,
					data: {
						...state.data,
						submitting: true
					}
				}

			case 'SUBMIT_FORM_STATUS':
				return {
					...state,
					date: {
						...state.data,
						status: action.status
					}
				}

			case 'SUBMIT_FORM_SUCCESS':
				return {
					...state,
					data: {
						...state.data,
						submitting: false,
						data: {},
						status: undefined
					}
				}

			case 'SUBMIT_FORM_FAILURE':
				var errors;
                //Only re-set the data if there was a validation error, i.e. bad request
                if (action.error.status === 403) {
                    errors = {
                        globalErrors: ['errors.sessionExpired']
                    }
                } else if (action.error.status === -1) {
                    errors = {
                        globalErrors: ['errors.noConnection']
                    }
                } else if (action.error.status === 400 && action.error.payload && action.error.payload.errors) {
                	errors = action.error.payload.errors;
                } else {
                    errors = {
                        globalErrors: ['errors.somethingWrong']
                    }
                }

				return {
					...state,
					data: {
						...state.data,
						submitting: false,
						status: undefined,
						errors
					}
				}

			default:
				return state;
		}
	}

	switch (action.type) {
		case 'FORM_FIELD_UPDATED':
		case 'RESET_FORM':
			return {
				...state,
				[action.formName]: updateApiState(state[action.formName], action)
			}

		case 'SUBMIT_FORM_REQUEST':
			return {
				...state,
				submitting: true,
				[action.formName]: updateApiState(state[action.formName], action)
			}

		case 'SUBMIT_FORM_STATUS':
			return {
				...state,
				status: action.status,
				[action.formName]: updateApiState(state[action.formName], action)
			}

		case 'SUBMIT_FORM_SUCCESS':
		case 'SUBMIT_FORM_FAILURE':
			return {
				...state,
				status: undefined,
				submitting: false,
				[action.formName]: updateApiState(state[action.formName], action)
			}

		default:
			return state;
	}
}

const formsReducer = combineReducers({
	forms: formReducer
})

export default formsReducer;


/** WEBPACK FOOTER **
 ** ./src/shared/form/reducer/formReducer.js
 **/